import Share from './Share'

export default class FacebookShare extends Share {
   constructor(element) {
      super(element)
   }

   onShare(params, event) {
      event.preventDefault()
      event.stopPropagation()
      FB.ui({
         method: 'share',
         href: params,
      }, console.log)
   }

   getParamsToShare() {
      return document.location.href
   }
}